import { useState } from "react";

import usePartShopifyUrl from "../../data/usePartShopifyUrl";
import { IPart } from "../../models/Part";
import openInNewTab from "../../utils/openInNewTab";

export default function MarketplacePills({ part }: { part: IPart }) {
  const hasEbay = Boolean(part.ebayItemNumber);
  const hasShopify = part.isPublishedOnShopify;
  const [fetchingShopify, setFetchingShopify] = useState(false);
  const { fetchShopifyUrl } = usePartShopifyUrl(part.id);

  if (!hasEbay && !hasShopify) return null;

  const handleEbay = (e: React.MouseEvent) => {
    e.stopPropagation();
    openInNewTab(`https://www.ebay.co.uk/itm/${part.ebayItemNumber}`);
  };

  const handleShopify = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setFetchingShopify(true);
    const url = await fetchShopifyUrl();
    setFetchingShopify(false);
    if (url) openInNewTab(url);
  };

  return (
    <div className="flex items-center gap-1 mt-1.5" onClick={(e) => e.stopPropagation()}>
      {hasEbay && (
        <button
          type="button"
          onClick={handleEbay}
          className="inline-flex items-center rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700 hover:bg-blue-200 transition-colors"
        >
          eBay
        </button>
      )}
      {hasShopify && (
        <button
          type="button"
          onClick={handleShopify}
          disabled={fetchingShopify}
          className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700 hover:bg-emerald-200 transition-colors disabled:opacity-60"
        >
          {fetchingShopify ? "…" : "Shopify"}
        </button>
      )}
    </div>
  );
}
